import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import Typography from "@mui/material/Typography";
import {memo} from "react";
import type {MouseEventHandler} from "react";

import {projectCardClasses as classes} from "./classes.js";

export interface StarMetricButtonProps {
    starred?: boolean;
    count?: number;
    /** Renders the control inert (e.g. while the starred state is still resolving) but keeps the count visible. */
    disabled?: boolean;
    onClick?: MouseEventHandler<HTMLElement>;
    "data-cy"?: string;
}

export function starMetricLabel(count: number | undefined): string {
    return (count ?? 0) > 0 ? `${count} ${count === 1 ? "Star" : "Stars"}` : "Star";
}

/**
 * The star control rendered as the leading entry of the card's metric row.
 */
export const StarMetricButton = memo(function StarMetricButton(props: StarMetricButtonProps) {
    const {starred, count, disabled, onClick} = props;
    const label = starMetricLabel(count);
    return (
        <Typography
            component="button"
            variant="body2"
            className={classes.starMetricButton}
            aria-label={label}
            disabled={disabled}
            onClick={onClick}
            data-cy={props["data-cy"]}
        >
            {starred ? <StarIcon /> : <StarBorderIcon />}
            <span className={classes.metricFullLabel}>{label}</span>
            <span className={classes.metricCompactLabel} aria-hidden>
                {count ?? 0}
            </span>
        </Typography>
    );
});
